import clsx from 'clsx';
import { Tip } from 'grommet';

import { Button } from '@/components/Buttons';
import RoundButton from '@/components/RoundButton';
import TipContent from '@/components/Tooltip';
import { getDesktopOrMobile } from '@/helpers';

interface AnimalAlertTriggerButtonProps {
  plain?: boolean;
  onClick?: () => void;
  className?: string;
}

const AnimalAlertTriggerButton = ({ plain, onClick, className }: AnimalAlertTriggerButtonProps) => {
  const device = getDesktopOrMobile();

  if (plain) {
    return (
      <Button
        variant="plain"
        size="manual"
        className={clsx('rounded-none border-0 bg-transparent', className)}
        onClick={onClick}
        aria-label="Flag animal alert"
      >
        <span className="text-2xl/none" aria-hidden="true">
          😮
        </span>
      </Button>
    );
  }

  if (device === 'mobile') {
    return (
      <div>
        <RoundButton
          onClick={onClick}
          width={36}
          backgroundColor="var(--secondaryGreen)"
          color="white"
          aria-label="Flag animal alert"
        >
          <span className="inline-flex size-full items-center justify-center text-lg/none" aria-hidden="true">
            😮
          </span>
        </RoundButton>
      </div>
    );
  }

  return (
    <Tip dropProps={{ align: { left: 'right' } }} content={<TipContent message="Flag animal alert" />} plain>
      <div>
        <RoundButton
          onClick={onClick}
          width={36}
          backgroundColor="var(--secondaryGreen)"
          color="white"
          aria-label="Flag animal alert"
        >
          <span className="inline-flex size-full items-center justify-center text-lg/none" aria-hidden="true">
            😮
          </span>
        </RoundButton>
      </div>
    </Tip>
  );
};

export default AnimalAlertTriggerButton;
